import React, { useCallback } from 'react'
import { Table } from 'antd'

export default function PageableTable({
  onChange,
  offset,
  limit,
  pagination: _pagination = {},
  total,
  ...ownProps
}) {
  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const params = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      params.sort = (sorter.order && sorter.order === 'descend' ? '' : '-' ) + sorter.field
    }
    window.scrollTop = 0

    onChange(params)
  }, [onChange])

  const pagination = Object.assign(_pagination)
  pagination.current =  Math.floor(offset / limit) + 1
  pagination.total = total
  pagination.pageSize = limit
  pagination.offset = offset

  return (
    <Table
      {...ownProps}
      rowKey="_id"
      pagination={pagination}
      onChange={handleTableChange}></Table>
  )
}
